// extracted by mini-css-extract-plugin
export default {"link":"o_V2Ga","handle":"v1EJBe","name":"uIeJeS","next":"FqLrL3"};